import React, { useState } from 'react';

//components
import BasicButton from '../global/buttons/BasicButton/BasicButton';
import Icon from '../icons/Icons';
import FixedPositionContextMenu from '../global/lists/FixedPositionContextMenu/FixedPositionContextMenu';

//interfaces
import { IconLibrary } from  '@/interfaces/IconLibrary';
import useContentAudience from './ContentAudience.hook';



const ActionsControl = ({isSingleUser, id, name, isAdmin, isLoading=false} : {isSingleUser:boolean, id: number, name:string, isAdmin: boolean, isLoading?: boolean}) => {
    const [controlIsOpen, setControlIsOpen] = useState<boolean>(false);

    const { getActionMenuButtons } = useContentAudience()

 

    return (
        <FixedPositionContextMenu
            className='action-wrapper' 
            controlIsOpen={controlIsOpen}
            setControlIsOpen={setControlIsOpen}
            anchorButton={<BasicButton
                className='action-button'
                ariaLabel={`View more actions for ${name}`}
                onButtonClick={() => setControlIsOpen(!controlIsOpen)}
                content={<Icon iconName={IconLibrary.MENU_MORE} color="#343D4C" sizeInPx="12"/> }
                isDisabled={isLoading}
            />}
            menuButtons={getActionMenuButtons(id, name, isAdmin)}
            closeOnScrollTarget='.simplebar-content-wrapper'
            containerQuerySelector='.ReactModal__Content'
            manualOffset={{right:32, top: 5}}
        />
    )
}

export default ActionsControl